export const aboutData = {
    title: "Who I am",
    description1: "My name is Shanelka. I'm an undergraduate student at Sri Lanka Institute of Information Technology (SLIIT).",
    description2: "I enjoy programming and have a passion for it. I am pursuing my studies while pursuing my interests.",
    image: 1
}